
import * as defaultImport from "@splunk/react-icons/Checkmark";
export * from "@splunk/react-icons/Checkmark";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
